import { Icon } from 'office-ui-fabric-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactMarkdown from 'react-markdown';
import ScrollableAnchor from 'react-scrollable-anchor';
import { FileList } from '../../../FileList';

const ConclusionFieldRead = ({
  conclusionTextValue,
  onDownloadFile,
  files,
}) => {
  const { t: translator } = useTranslation();

  return (
    <div
      className="create-hearing-form-field"
      aria-label={translator('ariaLabel.conclusionFieldRead')}
    >
      <ScrollableAnchor id="conclusion">
        <div>
          <div>
            <hr className="create-hearing-header-hr" />
            <h2 className="h2-style">
              {translator('hearingProperties.conclusion')}
            </h2>
            <div className="hearing-consultation hearing-conclusion-background">
              <Icon iconName="CheckMark" styles={iconStyles} />
              <ReactMarkdown
                source={conclusionTextValue || '-'}
                linkTarget={'_blank'}
              />
            </div>
          </div>
        </div>
      </ScrollableAnchor>
      <FileList
        onDownloadFile={onDownloadFile}
        items={files}
        headerText={translator('pages.hearingDetails.conclusionAppendix')}
      />
    </div>
  );
};

export { ConclusionFieldRead };

const iconStyles = {
  root: {
    paddingLeft: '10px',
    marginRight: '10px',
  },
};
